import { Roles } from 'common/constants/roles';

/**
 * Returns true if button should be disabled (user lacks ANY of the allowed roles)
 */
export const disableIfMissingAnyRole = (currentUserRoles: Roles[], allowedRoles: Roles[]): boolean => {
    const hasAnyRole = currentUserRoles?.some(r => allowedRoles.includes(r));
    return !hasAnyRole;
};

/**
 * Returns true if button should be disabled (user lacks ALL of the required roles)
 */
export const disableIfMissingAllRoles = (currentUserRoles: Roles[], requiredRoles: Roles[]): boolean => {
    const hasAllRoles = requiredRoles?.every(x => currentUserRoles.includes(x));
    return !hasAllRoles;
};
